// Components==============
import {
  faCheck,
  faSpinner,
  faTimes,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faClone,
  faCommentsAlt,
  faPencil,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ArrowButtons from 'components/UI/ArrowButtons/ArrowButtons';
import BigToggle from 'components/UI/BigToggle/BigToggle';
import Button from 'components/UI/Button/Button';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import Dropdown from 'components/UI/Dropdown/Dropdown';
import ProcessInfo from 'components/UI/ProcessInfo/ProcessInfo';
import Tooltip from 'components/UI/Tooltip/Tooltip';
import { useMediaQ } from 'hooks/useMediaQ';
import { usePermission } from 'hooks/usePermission';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext } from 'react';
import { ProjectDetailsContext } from '../../ProjectDetails';
import GroupManager from '../GroupManager/GroupManager';
import './Top.module.scss';
// =========================

const SaveButton = ({ canSave }: { canSave: boolean }) => {
  const translate = useTranslate();
  const { handleProcessSave, loading } = useContext(ProjectDetailsContext);
  const query = useMediaQ('min', 1024);
  const query2 = useMediaQ('max', 768);

  if (canSave)
    return (
      <Button onClick={() => handleProcessSave()}>
        {translate('general.terms.save')}
        <FontAwesomeIcon icon={loading ? faSpinner : faCheck} spin={loading} />
      </Button>
    );

  if (!query)
    return (
      <Tooltip
        content={translate('project.fill-fields-to-save')}
        position="top"
        clickContent={translate('project.fill-fields-to-save')}
        forceTop={query2}
      >
        <Button inactive>
          {translate('general.terms.save')}
          <FontAwesomeIcon icon={faCheck} />
        </Button>
      </Tooltip>
    );

  return (
    <Tooltip
      content={translate('project.fill-fields-to-save')}
      position="bottom"
    >
      <Button inactive>
        {translate('general.terms.save')}
        <FontAwesomeIcon icon={faCheck} />
      </Button>
    </Tooltip>
  );
};

const CommunicationButton = () => {
  const { setView, view } = useContext(ProjectDetailsContext);

  return (
    <CircleButton
      icon={view === 'project.terms.process-view' ? faCommentsAlt : faClone}
      onClick={() =>
        setView((prev) =>
          prev === 'project.terms.communication'
            ? 'project.terms.process-view'
            : 'project.terms.communication'
        )
      }
    />
  );
};

export default function Top() {
  const {
    project,
    isEditable,
    setIsEditable,
    scrollRef,
    selectedStudent,
    setSelectedStudent,
    studentList,
    isMember,
    userMembership,
    resetProcessGroups,
    processGroups,
    setView,
    view,
    hasStudents,
    setSparks,
  } = useContext(ProjectDetailsContext);

  const translate = useTranslate();
  const query = useMediaQ('min', 1024);
  const desktopLargeQuery = useMediaQ('min', 1325);
  const isTeacher = usePermission(['Docent', 'super-admin', 'Extern']);

  // useEffect(() => {
  //   if (!query) setIsEditable(false);
  // }, [query]);

  const startPoint = processGroups?.find(
    (group) => group.id === 6 && group.process_type === 'App\\Phase'
  )?.description as StartPointType;

  const endPoint = processGroups?.find(
    (group) => group.id === 7 && group.process_type === 'App\\Phase'
  )?.description as EndPointType;

  const canSave =
    startPoint?.design_question && endPoint?.delivery_goals?.length;

  // const canCommunicate =
  //   !isEditable &&
  //   !!((project?.members.length || 0) > 1) &&
  //   (isMember || userMembership === 'teacher' || userMembership !== 'extern');

  const canCommunicate = false;

  const isLocked = project?.locked_for_assessment === 1;

  const isExtern = usePermission(['Extern']);

  return (
    <div styleName="wrapper">
      <div styleName="left">
        <div styleName="top">
          <GroupManager />
          {canCommunicate && (
            <div styleName="communication-button">
              <CommunicationButton />
            </div>
          )}
        </div>
        <div styleName="row">
          {isTeacher && studentList.length > 1 && (
            <div>
              <p styleName="students">
                {studentList.length > 2
                  ? translate('project.terms.processes')
                  : translate('project.terms.process')}
                : {studentList.length - 1}
              </p>
              <div styleName="student-selector">
                <Dropdown
                  initialOptions={
                    studentList?.map((student) => student.name) as string[]
                  }
                  initialText={selectedStudent}
                  selectedItem={selectedStudent}
                  setSelectedItem={setSelectedStudent}
                />
              </div>
            </div>
          )}
          {!!processGroups.length && (
            <ProcessInfo processGroups={processGroups} />
          )}
        </div>
      </div>
      {!!processGroups.length && (
        <div styleName="right">
          {view === 'project.terms.process-view' && (
            //  query &&
            <>
              {query &&
                (userMembership === 'owner' || userMembership === 'admin') && (
                  <>
                    {isEditable ? (
                      <>
                        <Button
                          color="white"
                          onClick={() => {
                            setIsEditable(false);
                            resetProcessGroups();
                            setSparks(project?.sparks || []);
                          }}
                        >
                          {translate('general.terms.cancel')}
                          <FontAwesomeIcon icon={faTimes} />
                        </Button>
                        <SaveButton canSave={!!canSave} />
                      </>
                    ) : hasStudents ? (
                      <Tooltip
                        content={translate('project.already-students')}
                        position="bottom"
                      >
                        <CircleButton icon={faPencil} inactive />
                      </Tooltip>
                    ) : isExtern ? null : (
                      <CircleButton
                        onClick={() => setIsEditable((prev) => !prev)}
                        icon={faPencil}
                        inactive={isLocked}
                      />
                    )}
                  </>
                )}
              {!query && isMember && (
                <>
                  {isEditable && (
                    <>
                      {/* <Button
                        color="white"
                        onClick={() => {
                          setIsEditable(false);
                          resetProcessGroups();
                        }}
                      >
                        {translate('general.terms.cancel')}
                        <FontAwesomeIcon icon={faTimes} />
                      </Button> */}
                      <SaveButton canSave={!!canSave} />
                    </>
                  )}
                </>
              )}
              <ArrowButtons color="white" reference={scrollRef} />
            </>
          )}
          {canCommunicate && (
            <>
              {desktopLargeQuery ? (
                <BigToggle
                  selected={view}
                  setSelected={setView}
                  values={[
                    'project.terms.process-view',
                    'project.terms.communication',
                  ]}
                  white
                />
              ) : (
                <CommunicationButton />
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
